<div class="p-4 max-w-3xl mx-auto">
  <div class="flex justify-between items-center mb-6">
    <h2 class="text-2xl font-bold">
      {{ isEditMode ? ('::EditSommelier' | abpLocalization) : ('::NewSommelier' | abpLocalization) }}
    </h2>

    @if (form.get('status').value === 'Pending') {
    <app-metro-button [disabled]="form.invalid" variant="secondary" text="{{ '::Activated' | abpLocalization }}"
      (clicked)="activateSommelier()">
    </app-metro-button>
    }
  </div>


  <form [formGroup]="form" class="flex flex-col gap-2">
    <div>
      <label class="text-sm font-medium text-metro-black mb-1 block">
        {{ '::ProfileImage' | abpLocalization }}
      </label>
      <app-metro-upload-images [initialImageUrl]="imagePreviewUrl" (imageSelected)="onImageSelected($event)">
      </app-metro-upload-images>
    </div>
    <!-- Slug Field with Edit Button -->
    <div class="mb-4">
      <label class="text-sm font-medium text-metro-black mb-1 block">
        {{ "::Slug" | abpLocalization }}
      </label>
      <div class="flex items-center">
        @if (!isEditingSlug) {
        <div class="flex items-center w-full">
          <input type="text" [value]="currentSlug" class="w-full border border-gray-300 rounded px-3 py-2 mr-2"
            readonly />
          <app-metro-button variant="secondary" (clicked)="startEditingSlug()" text="{{ '::Edit' | abpLocalization }}">

          </app-metro-button>
        </div>
        } @else {
        <div class="flex items-center w-full">
          <input type="text" [value]="currentSlug" (input)="currentSlug = $event.target.value"
            class="w-full border border-gray-300 rounded px-3 py-2 mr-2 focus:shadow-outline"
            placeholder="{{ '::EnterNewSlug' | abpLocalization }}" />
          <app-metro-button type="button" (click)="saveSlug()" variant="primary"
            text="{{ '::Save' | abpLocalization }}">

          </app-metro-button>
          <app-metro-button type="button" (click)="cancelEditingSlug()" variant="secondary"
            text="{{ '::Cancel' | abpLocalization }}">
          </app-metro-button>
        </div>
        }
      </div>
    </div>
    <div class="flex gap-4">
      <app-metro-form-input class="flex-1" label='{{"::Name" | abpLocalization}}' formControlName="name"
        [placeholder]='"::Name" | abpLocalization' size="md" type="text">
      </app-metro-form-input>

      <app-metro-form-input class="flex-1" label='{{"::Surname" | abpLocalization}}' formControlName="surname"
        [placeholder]='"::Surname" | abpLocalization' size="md" type="email">
      </app-metro-form-input>
    </div>

    <!-- Fila 2: Password + ConfirmPassword -->
    <div>
      <label class="text-sm font-medium text-metro-black mb-1 block">
        {{ '::Telephone' | abpLocalization }}
      </label>
      <div class="flex gap-2">
        <select formControlName="countryDialCode"
          class="rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-metro-blue">
          <option *ngFor="let c of countryDialCodes" [value]="c.code">{{ c.label }}</option>
        </select>
        <app-metro-form-input class="flex-1" formControlName="localPhoneNumber"
          [placeholder]='"::Telephone" | abpLocalization' size="md" type="tel"
          [error]="getErrorMessage('localPhoneNumber')">
        </app-metro-form-input>
      </div>
    </div>

    <app-metro-form-input label='{{"::Email" | abpLocalization}}' formControlName="email"
      [placeholder]='"::Email" | abpLocalization' size="md" type="email">
    </app-metro-form-input>

    <app-metro-form-input label='{{"::Bio" | abpLocalization}}' formControlName="bio"
      [placeholder]='"::Bio" | abpLocalization' size="md" type="text"></app-metro-form-input>

    <app-metro-form-input label='{{"::Country" | abpLocalization}}' formControlName="country"
      [placeholder]='"::Country" | abpLocalization' size="md" type="text"></app-metro-form-input>

    <!-- Lista fija de provincias (antes era texto libre y terminó con decenas de variantes
         del mismo valor: "CABA"/"Caba"/"Buenos aires"/"BUENOS AIRES"/etc. — ver #334). -->
    <app-metro-form-select
      label="{{ '::Region' | abpLocalization }}"
      formControlName="region"
      [placeholder]="'::Region' | abpLocalization"
      [options]="provinceOptions"
      [allowSearch]="false"
      (selectionChange)="onRegionChange($event)"
      size="md">
    </app-metro-form-select>

    <!-- winepassport#343 / #354 — localidad dependiente de la provincia. Select con
         buscador cuando hay catálogo; texto libre si la provincia es "Otra". -->
    <app-metro-form-select *ngIf="!cityAsFreeText; else cityFreeText"
      label="{{ '::City' | abpLocalization }}"
      formControlName="city"
      [placeholder]="'::City' | abpLocalization"
      [options]="localityOptions"
      [allowSearch]="true"
      size="md">
    </app-metro-form-select>
    <ng-template #cityFreeText>
      <app-metro-form-input label='{{"::City" | abpLocalization}}' formControlName="city"
        [placeholder]='"::City" | abpLocalization' size="md" type="text"></app-metro-form-input>
    </ng-template>

    <app-metro-form-input label='{{"::Address" | abpLocalization}}' formControlName="address"
      [placeholder]='"::Address" | abpLocalization' size="md" type="text"></app-metro-form-input>

    <app-metro-form-input label='{{"::Specialities" | abpLocalization}}' formControlName="specialities"
      [placeholder]='"::Specialities" | abpLocalization' size="md" type="text"></app-metro-form-input>

    <app-metro-form-input label='{{"::Certification" | abpLocalization}}' formControlName="certification"
      [placeholder]='"::Certification" | abpLocalization' size="md" type="text"></app-metro-form-input>

    <app-metro-form-input label='{{"::PaymentAccountDetails" | abpLocalization}}'
      formControlName="paymentAccountDetails" [placeholder]='"::PaymentAccountDetails" | abpLocalization' size="md"
      type="text"></app-metro-form-input>

    <!-- winepassport#334 -->
    <app-metro-form-input label='{{"::PostalCode" | abpLocalization}}' formControlName="postalCode"
      [placeholder]='"::PostalCode" | abpLocalization' size="md" type="text"></app-metro-form-input>

    <app-metro-form-input label='{{"::AcademicInstitution" | abpLocalization}}'
      formControlName="academicInstitution" [placeholder]='"::AcademicInstitution" | abpLocalization' size="md"
      type="text"></app-metro-form-input>

    <app-metro-form-input label='{{"::Instagram" | abpLocalization}}' formControlName="instagram"
      [placeholder]='"::Instagram" | abpLocalization' size="md" type="text"></app-metro-form-input>

    <app-metro-form-input label='{{"::CommissionRate" | abpLocalization}}' formControlName="commissionRate"
      [placeholder]='"::CommissionRate" | abpLocalization' size="md" type="number" min="0"
      max="100"></app-metro-form-input>

    <!-- PickUps Selector -->
    <div>
      <label class="text-sm font-medium text-metro-black mb-1 block">
        {{ "::PickupPoints" | abpLocalization }}
      </label>
      <app-metro-form-select [multiple]="true" [options]="pickups$ | async" formControlName="pickUpIds"
        [placeholder]="'::SelectPickupLocation' | abpLocalization" size="md" selectedBackgroundClass="bg-metro-blue">
      </app-metro-form-select>
    </div>


    <!-- Buttons -->
    <div class="flex justify-end pt-4 gap-2">
      <app-metro-button variant="secondary" text="{{ '::Cancel' | abpLocalization }}"
        (clicked)="onCancel()"></app-metro-button>
      <app-metro-button variant="primary" [disabled]="form.invalid" (clicked)="onSubmit()"
        text="{{ isEditMode ? ('::SaveChanges' | abpLocalization) : ('::AddSommelier' | abpLocalization) }}"
        type="submit"></app-metro-button>
    </div>



  </form>
</div>